// import React, { useState,useEffect } from "react";
// import { useMutation, useApolloClient } from "@apollo/client";
// import { LOGIN_WITH_TOKEN_MUTATION } from '../../graphqlDefs/magicOuth/mutations';  

// export const useLoginWithToken = () => {
//   const client = useApolloClient();
//   const [loginWithTokenMutation, { data, error }] = useMutation(LOGIN_WITH_TOKEN_MUTATION);
//   const loginWithToken = async (token) => {
//     const { data, errors } = await loginWithTokenMutation({ variables: { token } });
//     return {
//       defaultPage: data?.loginWithToken?.defaultPage,
//       token: data?.loginWithToken?.token,
//     };
//   };
//   return {
//     loginWithToken, 
//   };
// };

// export default useLoginWithToken;

import React from "react";
import { useMutation, useApolloClient } from "@apollo/client";
import { LOGIN_WITH_TOKEN_MUTATION } from '../../graphqlDefs/magicOuth/mutations';

export const useLoginWithToken = () => {
  const client = useApolloClient();
  const [loginWithTokenMutation, { data, error }] = useMutation(LOGIN_WITH_TOKEN_MUTATION);

  const loginWithToken = async (token) => {
    try {
      const response = await loginWithTokenMutation({ variables: { token } });
      if (response.errors) {
        console.error('GraphQL errors:', response.errors);
        throw new Error('GraphQL errors occurred');
      }
      return {
        defaultPage: response.data?.loginWithToken?.defaultPage,
        token: response.data?.loginWithToken?.token,
      };
    } catch (error) {
      console.error('Error during loginWithToken:', error);
      throw error; // Rethrow error for further handling
    }
  };

  return {
    loginWithToken,
    error, // You can expose the error for further handling in the component
  };
};

export default useLoginWithToken;
